import { Translations } from "../Translations";
import { ExportMethod } from "../../model";
import { TableFormat } from "./TableFormat";
import { ImportResult } from "./ImportResult";
import { Tables } from "./Tables";
import { Culture } from "./Culture";

/** Defines a parser that parses a file (e.g. csv) to stadard tabular format. */
export class FileParser {

  public constructor(id: string, label: string, format: TableFormat, hasLocales = false) {
    this.id = id;
    this.label = label;
    this.format = format;
    this.hasLocales = hasLocales;
  }

  /** Id for the parser method */
  public id: string;

  /** Label for the method */
  public label: string;

  /** If true, supports locales for the data formatting.*/
  public hasLocales: boolean;

  /** Table format for the parser */
  public format?: TableFormat;

  /**
   * Does the actual parsing. In custom FileParsers, override this method
   * @param data Incoming data as a string
   * @param locale Optional locale selected by the user if supported by the parser.
   */
  public parse(data: string, locale?: Culture): ImportResult<any> {
    return Tables.import(data, this.format, this.hasLocales ? locale : null);
  }

  /**
   * Guesses the parser and locale that may be correct for the given data.
   * @param parsers Available parsers
   * @param data Data to be imported.
   * @returns Guessed parser and locale based on data or null if the parser cannot be guessed.
   */
  public static guessParser(parsers: FileParser[], data: string) : {
    parser: FileParser,
    locale: Culture,
  } {
    if (!data) {
      return null;
    }
    const lineFeedIx = /\r\n|\n/.exec(data)?.index;
    const firstRow = lineFeedIx ? data.substring(0, lineFeedIx) : data;
    const dataWithoutHeader = lineFeedIx ? data.substring(lineFeedIx) : "";
    if (firstRow.indexOf("\t") > 0) {
      const parser = parsers.find((x) => x.id == ExportMethod.CopyExcel);
      const decimalSeparator = /(^|\t|\n)-?\d+([.|,])\d+(\n|\t|$)/.exec(dataWithoutHeader)?.[2];
      return parser ? {
        parser,
        locale: decimalSeparator == "." ? Culture.En : Culture.Fi,
      } : null;
    }
    if (firstRow.indexOf(";") > 0) {
      const parser = parsers.find((x) => x.id == ExportMethod.FileCsv);
      return parser ? {
        parser,
        locale: Culture.Fi,
      } : null;
    }
    if (firstRow.indexOf(",") > 0) {
      const parser = parsers.find((x) => x.id == ExportMethod.FileCsv);
      return parser ? {
        parser,
        locale: Culture.En,
      } : null;
    }
  }

  /** Gets the standard methods that are typically supported. */
  public static getDefaultParsers(): FileParser[] {
    // Using, ExportMethod as ID, however, this is in no way required => If there is more, you may create your own enum.
    // TODO: Move texts to core and "CSV-tiedosto" => "Testitiedosto (CSV)"
    return [
      new FileParser(ExportMethod.CopyExcel, Translations.get("SALAXY.NG1.ODataActionsComponent.getDefaults.copyExcel"), TableFormat.Txt, true),
      new FileParser(ExportMethod.FileExcel, Translations.get("SALAXY.NG1.ODataActionsComponent.getDefaults.fileExcel"), TableFormat.Txt),
      new FileParser(ExportMethod.FileCsv, Translations.get("SALAXY.NG1.ODataActionsComponent.getDefaults.fileCsv"), TableFormat.Csv, true),
    ];
  }
}